"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiCircularProgress = getMuiCircularProgress;
function getMuiCircularProgress(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      size: 100
    },
    styleOverrides: {
      root: {
        '.MuiCircularProgress-circle': {
          strokeWidth: '3px'
        },
        color: palette.info.main
      }
    }
  };
}